const { isPlaceholderEmail } = require("./displayEmail");

/**
 * Returns a display name for a user object (first_name + last_name, or real email).
 * Never falls back to `@placeholder.local` system addresses.
 * @param {{ first_name?: string, last_name?: string, email_id?: string }} user
 * @returns {string}
 */
function getUserDisplayName(user) {
  if (!user) return "";
  const first = (user.first_name || "").trim();
  const last = (user.last_name != null ? String(user.last_name) : "").trim();
  const combined = [first, last].filter(Boolean).join(" ").trim();
  if (combined) return combined;
  const email = (user.email_id || "").trim();
  if (!email || isPlaceholderEmail(email)) return "";
  return email;
}

module.exports = { getUserDisplayName };
